import { useState } from 'react';
import DatamodelUpload from '../../../Settings/SettingsTabs/Datamodels/DataModelUpload';

export default function DatamodelSettings() {
  const [open, setOpen] = useState<boolean>(false);

  return <DatamodelUpload isOpen={open} setOpenModal={setOpen} isComponent />;
}
